<template>
<div class="page">
    <div class="box">
        <table border="1px">
            <tr>
                <td class="tit" style="width:13%;">第三方公司名称</td>
                <td class="tit" style="width:13%;">产品/服务</td>
                <td class="tit" style="width:15.19%;">涉及个人信息</td>
                <td class="tit" style="width:11%;">使用场景</td>
                <td class="tit" style="width:14%;">使用目的</td>
                <td class="tit" style="width:12%;">共享方式</td>
                <td class="tit" style="width:20%;">第三方链接</td>
            </tr>
            <tr>
                <td>友盟同欣（北京）科技有限公司</td>
                <td>友盟统计</td>
                <td>设备信息（IMEI、IMSI、AndroidID、MAC地址、BSSID、硬件序列号、ICCID）、定位信息、网络类型、设备型号、设备品牌、运营商信息</td>
                <td>用户打开应用时收集访客量，浏览量</td>
                <td>用于应用访客量、浏览量、错误日志数据收集</td>
                <td>SDK本机采集</td>
                <td style="20%">官网链接：https://www.umeng.com/analytics隐私政策链接：https://www.umeng.com/policy</td>
            </tr>
            <tr>
                <td>友盟同欣（北京）科技有限公司</td>
                <td>友盟分享</td>
                <td>设备信息（IMEI、IMSI、MAC地址、AndroidID）、网络信息、微信账号信息</td>
                <td>在用户进行信息分享时使用</td>
                <td>根据用户选择，为用户提供内容分享至第三方平台功能</td>
                <td>SDK本机采集</td>
                <td style="20%">官网链接：https://www.umeng.com/social隐私政策链接：https://www.umeng.com/policy</td>
            </tr>
            <tr>
                <td>深圳市和讯华谷信息技术有限公司</td>
                <td>极光推送</td>
                <td>设备信息（OAID、AndroidID）、网络类型、设备型号、应用信息（应用名、应用版本号）、位置信息</td>
                <td>向用户每次推送通知消息时使用</td>
                <td>根据用户机型，为用户提供通知信息推送功能</td>
                <td>SDK本机采集</td>
                <td style="20%">官网链接：https://www.jiguang.cn/push隐私政策链接：https://www.jiguang.cn/license/privacy</td>
            </tr>
            <tr>
                <td>财付通支付科技有限公司</td>
                <td>微信支付</td>
                <td>设备信息（IMEI、IMSI、MAC地址、AndroidID）、网络信息、微信账号信息</td>
                <td>在用户每次选择第三方支付方式时使用</td>
                <td>根据用户选择，为用户提供第三方支付功能</td>
                <td>SDK本机采集</td>
                <td style="20%">官网链接：https://pay.weixin.qq.com/static/applyment_guide/applyment_index.shtml隐私政策链接：https://www.tenpay.com/v3/helpcenter/low/privacy.shtml</td>
            </tr>
            <tr>
                <td>深圳市腾讯计算机系统有限公司</td>
                <td>微信</td>
                <td>设备信息（IMEI、IMSI、MAC地址、AndroidID）、网络信息、微信账号信息</td>
                <td>在用户进行信息分享时使用</td>
                <td>根据用户选择，为用户提供内容分享至第三方平台功能</td>
                <td>SDK本机采集</td>
                <td style="20%">官网链接：https://open.weixin.qq.com/隐私政策链接：https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&t=weixin_agreement&s=privacy</td>
            </tr>
        </table>
    </div>
    <p style="text-align:center">
        <span style="font-size:16px;font-weight: bold;font-family:&#39;微软雅黑&#39;,sans-serif">填呗合作商第三方名单</span>
    </p>
    <br>
    <p>
        <span style=";font-family:&#39;微软雅黑&#39;,sans-serif">在我们向您提供产品/服务时，我们会采取严格的安全措施，同时由于部分产品/服务是我们无法单独完成的，因此我们可能会与其他合作商等第三方共享或委托处理您的部分个人信息，以保障产品/服务的顺利完成。</span>
    </p>
    <div class="box">
        <table border="1px">
            <tr>
                <td class="tit" style="width:17%;">第三方产品/类型</td>
                <td class="tit" style="width:16%;">第三方公司名称</td>
                <td class="tit" style="width:15.19%;">涉及个人信息</td>
                <td class="tit" style="width:11%;">使用场景</td>
                <td class="tit" style="width:14%;">使用目的</td>
                <td class="tit" style="width:12%;">共享方式</td>
                <td class="tit" style="width:16%;">链接</td>
            </tr>
            <tr>
                <td style="writing-mode:tb-rl;text-align: center;vertical-align: middle;">第三方支付机构</td>
                <td>财付通支付科技有限公司</td>
                <td>订单交易信息、支付信息</td>
                <td>用户使用支付服务时提供</td>
                <td>根据用户选择，确认用户支付指令并完成支付</td>
                <td>接口传输</td>
                <td style="20%">官网链接：https://pay.weixin.qq.com/static/applyment_guide/applyment_index.shtml隐私政策链接：https://www.tenpay.com/v3/helpcenter/low/privacy.shtml</td>
            </tr>
        </table>
    </div>
</div>
</template>
<script>
export default {
  data () {
    return {
      
    }
  },
  components: {
  },
  created () {
  },
  mounted () {
  },
  computed:{
  },
  methods: {
  }
}
</script>
<style lang="less" scoped>
.page{
  width: 100%;
  height: 100vh;
  background-color: #f7f7f7;
  border-top: 2px solid #F5F5F5;
  padding: 32px 24px;
  box-sizing: border-box;
  // font-size: 28px;
  line-height: 50px;
  color: #666666;
  /deep/ strong{
    color: #333333;
    font-weight: bold !important;
  }
  span{
    font-size: 28px;
    color: #000;
  }
  .box{
    margin: 40px 0px;
    padding: 0px 1px 1px 0px;
    width: 1446px;
    overflow: auto hidden;
    counter-reset: cellnumber 0;
    table{
        border: 1px solid rgb(221, 221, 221);
        width: 97%;
        td{
            border: 1px solid rgb(221, 221, 221);
            padding: 9px 8px;
            box-sizing: border-box;
            font-size: 28px;
            color: #000;
            word-break: break-word;
        }
        .tit{
            text-align: center;
            font-size: 28px;
            font-weight: bold;
            background-color: rgb(239, 239, 239);
            color: rgb(51, 51, 51);
        }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/other/sdkInfo.vue